var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "mx-0 justify-content-center interstitial-row" },
    [
      _c("b-col", { attrs: { lg: "6", sm: "9", cols: "11" } }, [
        _c(
          "div",
          { staticClass: "card interstitial-card" },
          [
            _c(
              "b-col",
              {
                staticClass: "d-flex align-items-center justify-content-center",
                staticStyle: { "max-height": "5rem" },
              },
              [_c("b-skeleton", { attrs: { width: "100%", height: "30px" } })],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-body", attrs: { id: "#main-content" } },
              [
                _c("b-skeleton", {
                  staticClass: "mb-2",
                  attrs: { width: "10rem", height: "15px" },
                }),
                _vm._v(" "),
                _c("b-skeleton", {
                  staticClass: "mb-2",
                  attrs: { width: "100%", height: "80px" },
                }),
                _vm._v(" "),
                _c("b-skeleton", {
                  staticClass: "mb-2",
                  attrs: { width: "100%", height: "80px" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "card-footer text-right justify-content-between d-flex flex-row",
              },
              [
                _c("b-skeleton", { attrs: { width: "8rem", height: "2rem" } }),
                _vm._v(" "),
                _c("b-skeleton", { attrs: { width: "8rem", height: "2rem" } }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }